var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "card donation",
      class: { "d-none": _vm.donationActive, smallCard: !_vm.isLarge },
    },
    [
      _vm.isLarge
        ? [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("h2", { staticClass: "headline" }, [
                _c("img", {
                  attrs: {
                    src: "https://cdn.bio-kinder.de/frontend/images/forest/headline.svg",
                    alt: "BioKinder forstet auf!",
                  },
                }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "counter",
                    attrs: {
                      href: "/aufforstung-mit-biokinder/spendenstand/",
                      "data-target": _vm.numTreesPlanted,
                    },
                  },
                  [_c("div", { staticClass: "dot-flashing" })]
                ),
              ]),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c("label", [
                _c("input", {
                  ref: "enableDonation",
                  staticClass: "mr-2",
                  attrs: {
                    type: "checkbox",
                    disabled: _vm.waiting || !_vm.basketFullyLoaded,
                  },
                  on: { change: _vm.onOff },
                }),
                _vm._v(" "),
                _c("span", [
                  _vm._v("Ich möchte für 5,00€ einen Baum pflanzen!"),
                ]),
              ]),
            ]),
          ]
        : [
            _c("div", { staticClass: "card-body flex-row" }, [
              _c("label", [
                _c("input", {
                  ref: "enableDonationSmall",
                  staticClass: "mr-2",
                  attrs: {
                    type: "checkbox",
                    disabled: _vm.waiting || !_vm.basketFullyLoaded,
                  },
                  on: { change: _vm.onOff },
                }),
                _vm._v(" "),
                _vm._m(2),
              ]),
              _vm._v(" "),
              _c("a", { attrs: { href: "/aufforstung-mit-biokinder/" } }, [
                _vm._v("Mehr Informationen"),
              ]),
            ]),
          ],
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "donateModal",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "aufforsten-headline",
            "aria-hidden": "true",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog", attrs: { role: "document" } },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-body text-center" }, [
                  _c("img", {
                    staticClass: "hessenforst_biokinder_banner",
                    attrs: {
                      loading: "lazy",
                      src: "https://cdn.bio-kinder.de/frontend/images/forest/hf-bk-2.svg",
                      alt: "BioKinder & HessenForst",
                    },
                  }),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n                        In den vergangenen Jahren ist uns immer deutlicher geworden, wie sich zu trockene Bedingungen\n                        im Sommer negativ auf unsere Wälder ausgewirkt haben. Immer häufiger sind große,\n                        leere Flächen zu sehen, wo früher einmal ein dichter Wald gewachsen ist.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._m(3),
                  _vm._v(" "),
                  _c("ul", { staticClass: "list-group cleanList text-left" }, [
                    _c("li", { staticClass: "list-group-item" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "css-i6dzq1",
                          attrs: {
                            viewBox: "0 0 24 24",
                            width: "24",
                            height: "24",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            fill: "none",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("polyline", {
                            attrs: { points: "20 6 9 17 4 12" },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n                            100%-Spende – Keine versteckten Gebühren, kein Kleingedrucktes\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "list-group-item" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "css-i6dzq1",
                          attrs: {
                            viewBox: "0 0 24 24",
                            width: "24",
                            height: "24",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            fill: "none",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("polyline", {
                            attrs: { points: "20 6 9 17 4 12" },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n                            Heimische Bäume für einen gesunden Mischwald\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "list-group-item" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "css-i6dzq1",
                          attrs: {
                            viewBox: "0 0 24 24",
                            width: "24",
                            height: "24",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            fill: "none",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("polyline", {
                            attrs: { points: "20 6 9 17 4 12" },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n                            Wir pflanzen im Herzen des schönen Taunus\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "list-group-item" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "css-i6dzq1",
                          attrs: {
                            viewBox: "0 0 24 24",
                            width: "24",
                            height: "24",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            fill: "none",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("polyline", {
                            attrs: { points: "20 6 9 17 4 12" },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n                            Betreuung durch HessenForst vom Setzling bis zum Baum\n                        "
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _vm._m(4),
              ]),
            ]
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "wait" }, [
      _c("div", { staticClass: "dot-flashing" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "\n                Gemeinsam mit HessenForst pflanzen wir nachhaltig Bäume lokal bei uns im Taunus. Dort werden sie über Jahre gepflegt und großgezogen.\n                "
      ),
      _c("br"),
      _c(
        "a",
        {
          attrs: {
            tabindex: "0",
            "data-toggle": "modal",
            "data-target": "#donateModal",
          },
        },
        [_vm._v("Mehr Informationen")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _vm._v("Ich möchte für 5,00€ einen"),
      _c("br"),
      _vm._v("Baum im Taunus pflanzen."),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "\n                        In Zusammenarbeit mit HessenForst haben wir eine transparente Kooperation auf die Beine gestellt,\n                        bei der die Spenden bis auf den letzten Cent dafür eingesetzt werden, wofür sie gedacht sind:\n                        "
      ),
      _c("b", [_vm._v("Das Pflanzen neuer Bäume")]),
      _vm._v("!\n                    "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-footer" }, [
      _c(
        "a",
        {
          staticClass: "btn btn-bkm btn-sm mr-auto",
          attrs: { href: "/aufforstung-mit-biokinder/" },
        },
        [_vm._v("Noch mehr erfahren >")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-bkm-inverted btn-sm ml-auto",
          attrs: { type: "button", "data-dismiss": "modal" },
        },
        [_vm._v("Schließen")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }